<template>
  <a-modal
    v-model:open="open"
    :centered="true"
    :footer="null"
    :title="$t('qi-ye-ti-yan-ban-zhang-hao-da-dao-shang-xian')"
  >
    <AccountList :accounts="tasteAccounts">
      <slot />
    </AccountList>
  </a-modal>
</template>
<script lang="ts" setup>
import AccountList from './accountList.vue';
import { USER_ADMIN } from '~/constants';
import { USER_LEVEL_KEY, type LoginInfo } from '~/api/interface';

const props = defineProps({
  open: {
    type: Boolean,
    default: false,
  },
  accounts: {
    type: Array as PropType<LoginInfo[]>,
  },
});

const emit = defineEmits(['update:open']);

const open = useVModel(props, 'open', emit);

const tasteAccounts = computed(() => {
  return (
    props.accounts?.filter(item => {
      return (
        item.rights_type === USER_LEVEL_KEY.TEAM_TASTE &&
        Number(item.permission) !== USER_ADMIN.NORMAL
      );
    }) || []
  );
});
</script>
